import React, { useEffect, useState } from "react";
import Select from "react-select";

import { Modal } from "react-bootstrap";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { editSinglePair, getAllTokens } from "../actions/currency";
import toast from "react-hot-toast";

const EditPairModal = ({ show, handleClose, record, getAllPairs }) => {
  const [formvalue, setFormvalue] = useState({});
  const [errors, setErrors] = useState({});

  const [tokens, setTokens] = useState();

  useEffect(() => {
    console.log(record, "record");
    getTokens();
    setFormvalue(record);
  }, [record]);

  const getTokens = async () => {
    try {
      let { status, message, result } = await getAllTokens();
      setTokens(result);
    } catch (err) {
      console.log("getAllTokens_err", err);
    }
  };

  tokens?.map((val) => {
    val["label"] = val.name + "-" + val.chainId;
    val["value"] = val.name;
  });

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let Formvalue = { ...formvalue, [name]: value };
      setFormvalue(Formvalue);
      // setErrors(validation(Formvalue));
    } catch (err) {
      console.log(err, "handleChange");
    }
  };
  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => {
      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00ddeb"
          : isSelected
          ? "#00ddeb"
          : isFocused
          ? "#00ddeb"
          : "#000",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
          ? "#000"
          : isFocused
          ? "#000"
          : "#fff",
        fontSize: "13px",
        zIndex: 1,
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",

      backgroundColor: "transparent",
      color: "red",
      border: "none",
      borderRadius: 0,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "red",
      padding: "0px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#ffffff",
    }),
    menuList: (base) => ({
      ...base,

      padding: 0,
      width: "100%",

      borderRadius: 5,
      background: "transparent",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#fff",
      };
    },
  };

  const [selectedOption1, setSelectedOption1] = useState("Theme 1");

  const handleChange1 = (e) => {
    if (e?.address == formvalue?.token2?.address) {
      let Formvalue = { ...formvalue, ["token1"]: e };
      setFormvalue(Formvalue);
      setSelectedOption1(e);
      let error = { ...errors };
      error = { ...error, ["token1"]: "Token1 And Token2 Should'nt Same" };
      setErrors(error);
    } else if (
      formvalue?.token2?.chainId != undefined &&
      e?.chainId != formvalue?.token2?.chainId
    ) {
      let Formvalue = { ...formvalue, ["token1"]: e };
      setFormvalue(Formvalue);
      let error = { ...errors };
      setSelectedOption1(e);
      error = {
        ...error,
        ["token1"]: "Token1 And Token2 Must In Same Network",
      };
      setErrors(error);
    } else {
      let Formvalue = { ...formvalue, ["token2"]: e };
      setFormvalue(Formvalue);
      setSelectedOption1(e);
      let error = { ...errors };
      error = { ...error, ["token1"]: "" };
      error = { ...error, ["token2"]: "" };
      setErrors(error);
    }
  };

  const [selectedOption2, setSelectedOption2] = useState("Theme 1");

  const handleChange2 = (selectedOption) => {
    if (selectedOption?.address == formvalue?.token1?.address) {
      let Formvalue = { ...formvalue, ["token2"]: selectedOption };
      setFormvalue(Formvalue);
      setSelectedOption2(selectedOption);
      let error = { ...errors };
      error = { ...error, ["token2"]: "Token1 And Token2 Should'nt Same" };
      setErrors(error);
    } else if (
      formvalue?.token1?.chainId != undefined &&
      selectedOption?.chainId != formvalue?.token1?.chainId
    ) {
      let Formvalue = { ...formvalue, ["token2"]: selectedOption };
      setFormvalue(Formvalue);
      let error = { ...errors };
      setSelectedOption2(selectedOption);
      error = {
        ...error,
        ["token2"]: "Token1 And Token2 Must In Same Network",
      };
      setErrors(error);
    } else {
      let Formvalue = { ...formvalue, ["token2"]: selectedOption };
      setFormvalue(Formvalue);
      setSelectedOption2(selectedOption);
      let error = { ...errors };
      error = { ...error, ["token1"]: "" };
      error = { ...error, ["token2"]: "" };
      setErrors(error);
    }
  };

  const validation = (value) => {
    try {
      let error = errors;

      if (isEmpty(value.token1)) {
        error["token1"] = "Field is required";
      } else {
        error["token1"] = "";
      }
      if (isEmpty(value.token2)) {
        error["token2"] = "Field is required";
      } else if (value.token1?.name == value.token2?.name) {
        error["token2"] = "Token1 And Token2 Should'nt Same";
      } else {
        error["token2"] = "";
      }
      // if (isEmpty(value.chainId)) {
      //   error["chainId"] = "Field is required";
      // } else {
      //   error["chainId"] = "";
      // }
      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {
      let tokenData = {
        _id: record._id,
        token1: formvalue.token1,
        token2: formvalue.token2,
        chainId: formvalue.chainId,
      };
      let isValidate = validation(tokenData);
      setErrors(isValidate);
      if (!ObjectIsempty(isValidate)) {
        return true;
      }
      let { status, message, result } = await editSinglePair(tokenData);
      if (status == "success") {
        // toastAlert("success", "Pair Added Successfully");
        toast.success("Pair Edited Successfully");
        handleClose();
        getAllPairs();
      } else {
        toast.error(message);
        handleClose();
        getAllPairs();
      }
      handleClose();
      getAllPairs();
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };
  const HandleClose = () => {
    handleClose();
    setFormvalue({});
    setSelectedOption1("");
    setSelectedOption2("");
    setErrors({});
  };
  return (
    <>
      <Modal
        centered
        className="cmn_modal"
        show={show}
        onHide={HandleClose}
        backdrop="static"
        keyboard={false}>
        <Modal.Body>
          <div className="cmn_modal_header d-flex justify-content-between align-items-center">
            <p className="cmn_modal_title">Edit Pairs</p>
            <button
              className="cmn_modal_closer rounded-5"
              onClick={() => {
                HandleClose();
              }}>
              <i class="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="mt-4">
            {/* <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Name</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formvalue?.name}
                  className="rp_singleInput flex-grow-1"
                  onChange={handleChange}
                />
                <span>{errors && errors.name}</span>
              </div>
            </div>

            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Pair</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="pair"
                  name="pair"
                  value={formvalue?.pair}
                  className="rp_singleInput flex-grow-1"
                  onChange={handleChange}
                />
                <span>{errors && errors.pair}</span>
              </div>
            </div>

            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Symbol</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="symbol"
                  name="symbol"
                  value={formvalue?.symbol}
                  className="rp_singleInput flex-grow-1"
                  onChange={handleChange}
                />
                <span>{errors && errors.symbol}</span>
              </div>
            </div> */}
            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Token 1 Address</p>
              <div className="rp_input_holder rounded-2 px-0">
                <Select
                  onChange={(e) => handleChange1(e)}
                  options={tokens}
                  defaultValue="theme1"
                  styles={stylesgraybg}
                  isSearchable={false}
                  classNamePrefix="customselect"
                  value={
                    formvalue.token1 &&
                    tokens?.find((val) => val?.name == formvalue?.token1.name)
                  }
                  // defaultInputValue="Theme 1"
                  // menuIsOpen
                />
              </div>
              <span className="text-danger">{errors && errors.token1}</span>
            </div>

            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Token 2 Address</p>
              <div className="rp_input_holder rounded-2 px-0">
                <Select
                  onChange={(e) => handleChange2(e)}
                  options={tokens}
                  defaultValue="theme1"
                  styles={stylesgraybg}
                  isSearchable={false}
                  classNamePrefix="customselect"
                  value={
                    formvalue.token2 &&
                    tokens?.find((val) => val?.name == formvalue?.token2.name)
                  }
                />
              </div>
              <span className="text-danger">{errors && errors.token2}</span>
            </div>

            {/* <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Chain Id</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  name="chainId"
                  readOnly
                  placeholder="Enter Chain Id"
                  className="rp_singleInput flex-grow-1"
                  value={formvalue.chainId}
                  onChange={handleChange}
                />
                <span>{errors && errors.chainId}</span>
              </div>
            </div> */}

            <button
              className="orange_small_primary mt-3"
              onClick={() => {
                handleSubmit();
              }}>
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditPairModal;
